// Status core
export function statusCore() {
  const endpoint = '/trims/status';

  return {
    endpoint
  };
}

// Status filter
export function statusFilter() {
  const parameter = 'Status';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.statusId,
        label: row.statusDescription
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
